import { useState } from "react";
import { BeforeAfter } from "@/components/SkinSection";

const CYAN = "#00e5ff";
const VIEWS = [
  { id: "full", tab: "Full frame", before: "/denoise-street-before-v2.jpg", after: "/denoise-street-after-v2.jpg" },
  { id: "zoom", tab: "2x zoom", before: "/denoise-street-before-zoom-v3.jpg", after: "/denoise-street-after-zoom-v3.jpg" },
];

export function DenoiseStill() {
  const [v, setV] = useState(VIEWS[0]);
  return (
    <div className="space-y-3" data-testid="denoise-still">
      <div className="flex flex-wrap gap-2" data-testid="denoise-still-tabs">
        {VIEWS.map((x) => (
          <button key={x.id} onClick={() => setV(x)} className="px-3 py-1.5 text-xs font-mono uppercase tracking-wider border transition-colors"
            style={v.id === x.id ? { borderColor: CYAN, color: "#000", background: CYAN } : { borderColor: "#2a2f3d", color: "#9ba3b4" }} data-testid={`denoise-still-tab-${x.id}`}>{x.tab}</button>
        ))}
      </div>
      <BeforeAfter key={v.id} id="denoise" before={v.before} after={v.after} color={CYAN} beforeLabel="noisy source" label="KolorKlinic Denoise" alt="Night street cleaned with KolorKlinic Denoise" />
    </div>
  );
}
